import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import Env from "./views/Env.vue";
import Test from "./views/Test.vue";
import User from "./views/User.vue";
import Main from "./views/Main.vue";
import Envs from "./views/Envs.vue";
import Tags from "./views/Tags.vue";
import Graph from "./views/Graph.vue";
import Test2 from "./views/Test2.vue";
import Share from "./views/Share.vue";
import Stats from "./views/Stats.vue";
import Users from "./views/Users.vue";
import Group from "./views/Group.vue";
import Style from "./views/Style.vue";
import notFound from "./views/404.vue";
import Groups from "./views/Groups.vue";
import Agenda from "./views/Agenda.vue";
import Create from "./views/Create.vue";
import Logout from "./views/Logout.vue";
import Sandbox from "./views/Sandbox.vue";
import Actions from "./views/Actions.vue";
import Viewver from "./views/Viewver.vue";

import Profile from "./views/Profile.vue";
import Element from "./views/Element.vue";
import Library from "./views/Library.vue";
import createForm from "./views/Form.vue";
import Message from "./views/Message.vue";
import Workflow from "./views/Workflow.vue";
import Register from "./views/Register.vue";
import ShareGet from "./views/ShareGet.vue";
import Messages from "./views/Messages.vue";
import Scraping from "./views/Scraping.vue";
import Document from "./views/Document.vue";
import Ensemble from "./views/Ensemble.vue";
import Variants from "./views/Variants.vue";
import LoginSSO from "./views/LoginSSO.vue";
import Database from "./views/database.vue";
import DatabaseSync from "./views/DatabaseSync.vue";
import Mapping from "./views/gcr/mapping.vue";
import Dashboard from "./views/Dashboard.vue";
import AgendaJob from "./views/AgendaJob.vue";
import Treatment from "./views/Treatment.vue";
import ClientVar from "./views/ClientVar.vue";
import LoginOauth from "./views/LoginOauth.vue";
import Formulaire from "./views/Formulaire.vue";
import Project_v2 from "./views/Project_v2.vue";
import Treatments from "./views/Treatments.vue";
import LoginAdmin from "./views/LoginAdmin.vue";
import Validation from "./views/Validation.vue";
import Prestashop from "./views/Prestashop.vue";
import AdminClient from "./views/AdminClient.vue";
import AdminCredit from "./views/AdminCredit.vue";
import GlobalStats from "./views/GlobalStats.vue";
import CompareFile from "./views/CompareFile.vue";
import Credentials from "./views/Credentials.vue";
import EditProfile from "./views/EditProfile.vue";
import MessageSend from "./views/MessageSend.vue";
import Notification from "./views/Notification.vue";
import ConnexionsBDD from "./views/ConnexionsBDD.vue";
import OAuthRedirect from "./views/OAuthRedirect.vue";
import Documentation from "./views/Documentation.vue";
import RegisterCheck from "./views/RegisterCheck.vue";
import Notifications from "./views/Notifications.vue";
import ViewverParams from "./views/ViewverParams.vue";
import DatabaseRecap from "./views/DatabaseRecap.vue";
import FormTreatment from "./views/FormTreatment.vue";
import ActionsConfig from "./views/ActionsConfig.vue";
import Characteristics from "./views/Characteristics.vue";
import ValidateOnp from "./views/phar_excel/validateOnp.vue";
import DocumentExtraction from "./views/DocumentExtraction.vue";
import NotificationsClient from "./views/NotificationsClient.vue";
import DatabaseRequestView from "./views/DatabaseRequestView.vue";
import GoogleSearch from "./views/green_musicians/googleSearch.vue";
import Documentation_gcr from "./views/gcr/Documentation_client.vue";
import ValidateProducts from "./views/green_musicians/validateProducts.vue";
import ExtractionDocumentConfiguration from "./views/ExtractionDocumentConfiguration.vue";
import TicketsList from "./views/TicketsList.vue";
import TicketDetail from "./views/TicketDetail.vue";
import TacheMapping from "./views/TacheMapping.vue";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "main",
			component: Main,
		},
		{
			path: "/create",
			name: "create",
			component: Create,
		},
		{
			path: "/dashboard",
			name: "dashboard",
			component: Dashboard,
		},
		{
			path: "/test2",
			name: "test2",
			component: Test2,
		},
		{
			path: "/test",
			name: "test",
			component: Test,
		},
		{
			path: "/login",
			name: "login",
			component: () => { 
			  if (process.env.VUE_APP_CLIENT === 'croec') {
				  //console.log("croec")
				return import('@/views/croec/Login.vue');
			  } else {
				return import('@/views/Login.vue');
			  }
		   }
		},
		{
			path: "/register/:token",
			name: "register_token",
			component: () => { 
			  if (process.env.VUE_APP_CLIENT === 'croec') {
				  //console.log("croec")
				return import('@/views/croec/Register.vue');
			  } else {
				return import('@/views/Register.vue');
			  }
		   }
		},
		{
			path: "/register",
			name: "register",
			component: Register,
		},
		{
			path: "/register/check/:client_user_uid/:token",
			name: "register_check",
			component: RegisterCheck,
		},
		{
			path: "/login_admin",
			name: "login_admin",
			component: LoginAdmin,
		},
		{
			path: "/login_oauth",
			name: "login_oauth",
			component: LoginOauth,
		},
		{
			path: "/login_sso",
			name: "login_sso",
			component: LoginSSO,
		},
		{
			path: "/password/:id",
			name: "password",
			component: () => { 
			  if (process.env.VUE_APP_CLIENT === 'croec') {
				  //console.log("croec")
				return import('@/views/croec/Password.vue');
			  } else {
				return import('@/views/Password.vue');
			  }
		   }
		},
		{
			path: "/password_reset",
			name: "password_reset",
			component: () => { 
			  if (process.env.VUE_APP_CLIENT === 'croec') {
				  //console.log("croec")
				return import('@/views/croec/PasswordReset.vue');
			  } else {
				return import('@/views/PasswordReset.vue');
			  }
		   }
		},
		{
			path: "/logout",
			name: "logout",
			component: Logout,
		},
		{
			path: "/actions",
			name: "actions",
			component: Actions,
		},
		{
			path: "/share",
			name: "share",
			component: Share,
		},
		{
			path: "/share_get",
			name: "share_get",
			component: ShareGet,
		},
		{
			path: "/treatments",
			name: "treatments",
			component: Treatments,
		},
		{
			path: "/profile",
			name: "profile",
			component: Profile,
		},
		{
			path: "/edit-profile",
			name: "edit-profile",
			component: EditProfile,
		},
		{
			path: "/database",
			name: "database_recap",
			component: DatabaseRecap,
		},
		{
			path: "/database_requests",
			name: "database_request",
			component: Library,
			props: { _type: "db", _title: "Requêtes DB" }
		},
		{
			path: "/database_requests_view",
			name: "database_request_view",
			component: DatabaseRequestView
		},
		{
			path: "/database/:table",
			name: "database",
			component: Database,
		},
		{
			path: "/database-sync",
			name: "database_sync",
			component: DatabaseSync,
		},
		{
			path: "/tickets",
			name: "TicketsList",
			component: TicketsList,
		},
		{
			path: "/ticket/:id",
			name: "TicketDetail",
			component: TicketDetail,
		},
		{
			path: "/tache/mapping",
			name: "TacheMapping",
			component: TacheMapping,
		},
		{
		path: "/database_connections",
		name: "database_connections",
		component: ConnexionsBDD
		},
		{
			path: "/oauth/callback",
			name: "oauth_callback",
			component: OAuthRedirect
		},
		{
			path: "/treatment/:id",
			name: "treatment",
			component: Treatment,
		},
		{
			path: "/scenario",
			name: "project",
			component: Project_v2,
		},
		{
			path: "/scenario/:id",
			name: "project_id",
			component: Project_v2,
		},
		{
			path: "/credentials",
			name: "creentials",
			component: Credentials,
		},
		{
			path: "/gcr/mapping",
			name: "mapping",
			component: Mapping,
		},
		{
			path: "/phar_excel/validate_onp",
			name: "validate_onp",
			component: ValidateOnp,
		},
		{
			path: "/green_musicians/validate_products",
			name: "validate_products",
			component: ValidateProducts,
		},
		{
			path: "/green_musicians/google_search",
			name: "gooogle_search",
			component: GoogleSearch,
		},
		{
			path: "/validation",
			name: "validation",
			component: Validation,
		},
		{
			path: "/graph",
			name: "Graph",
			component: Graph,
		},
		{
			path: "/visualisation/parametres",
			name: "viewver_params",
			component: ViewverParams,
		},
		{
			path: "/visualisation/:name",
			name: "viewver",
			component: Viewver,
		},
		{
			path: "/element",
			name: "element",
			component: Element,
		},
		{
			path: "/bibliotheque",
			name: "library",
			component: Library,
		},
		{
			path: "/caracteristiques",
			name: "caracteristiques",
			component: Library,
			props: { _type: "characteristics", _title: "Recherche de caractéristiques" }
		},
		{
			path: "/ensemble",
			name: "ensemble",
			component: Ensemble,
		},
		{
			path: "/variants",
			name: "variants",
			component: Variants,
		},
		{
			path: "/planification",
			name: "planification",
			component: Agenda,
		},
		{
			path: "/planification/:id",
			name: "planification_job",
			component: AgendaJob,
		},
		{
			path: "/documentation",
			beforeEnter() {
				window.open("https://docs.smartmydata.com", "_blank");
			},
		},
		{
			path: "/gcr/documentation",
			name: "documentation",
			component: Documentation_gcr,
		},
		{
			path: "/groupes",
			name: "groupes",
			component: Groups,
		},
		{
			path: "/groupe/:id",
			name: "groupe",
			component: Group,
		},
		{
			path: "/envs",
			name: "envs",
			component: Envs,
		},
		{
			path: "/env/:id",
			name: "env",
			component: Env,
		},
		{
			path: "/utilisateurs",
			name: "utilisateurs",
			component: Users,
		},
		{
			path: "/utilisateur/:id",
			name: "utilisateur",
			component: User,
		},
		{
			path: "/scraping",
			name: "scraping",
			component: Scraping,
		},
		{
			path: "/document",
			name: "Document",
			component: Document,
		},
		{
			path: "/document/:path(.*)",
			name: "Document_path",
			component: Document,
		},
		{
			path: "/style",
			name: "style",
			component: Style,
		},
		{
			path: "/actions_config",
			name: "actionsConfig",
			component: ActionsConfig,
		},
		{
			path: "/compare",
			name: "compare",
			component: CompareFile,
		},
		{
			path: "/extraction_document",
			name: "documentExtraction",
			component: DocumentExtraction,
		},
		{
			path: "/extraction_document_configuration",
			name: "ExtractionDocumentConfiguration",
			component: ExtractionDocumentConfiguration,
		},
		{
			path: "/form",
			name: "createForm",
			component: createForm,
		},
		{
			path: "/var",
			name: "clientVar",
			component: ClientVar,
		},
		{
			path: "/form/:key",
			name: "FormTreatment",
			component: FormTreatment,
		},
		{
			path: "/formulaire/:id?",
			name: "Formulaire",
			component: Formulaire,
		},
		{
			path: "/notifications",
			name: "notifications",
			component: Notifications,
			props: true,
		},
		{
			path: "/notifications_client",
			name: "notificationsClient",
			component: NotificationsClient	
		},
		{
			path: "/stats",
			name: "Stats",
			component: Stats
		},
		{
			path: "/global_stats",
			name: "GlobalStats",
			component: GlobalStats
		},
		{
			path: "/prestashop",
			name: "Prestashop",
			component: Prestashop
		},
		{
			path: "/notification/:id",
			name: "notification",
			component: Notification,
		},
		{
			path: "/messages",
			name: "messages",
			component: Messages
		},
		{
			path: "/message/:id",
			name: "message",
			component: Message
		},
		{
			path: "/message_send",
			name: "message_send",
			component: MessageSend
		},
		{
			path: "/doc",
			name: "doc",
			component: Documentation
		},
		{
			path: "/tags",
			name: "tags",
			component: Tags
		},
		{
			path: "/admin_credit",
			name: "admin_credit",
			component: AdminCredit
		},
		{
			path: "/admin_client",
			name: "admin_client",
			component: AdminClient
		},
		{
			path: "/sandbox",
			name: "sandbox",
			component: Sandbox
		},
		{
			path: "/workflow",
			name: "workflow",
			component: Workflow
		},
		{
			path: "/workflow/:mode",
			name: "workflow",
			component: Workflow
		},
		{
			path: "/*",
			name: "404",
			component: notFound,
		},
	],
});

router.beforeEach((to, from, next) => {
	//if (from.database == to.database)
	//console.log(to);

	if (!to.path.startsWith("/login") && 
		!to.path.startsWith("/password") && 
		!to.path.startsWith("/form/") &&
		!to.path.startsWith("/register")) {
		let jwt = store.state.jwt;
		if (jwt) {
			next();
		} else {
			next("login");
		}
	} else {
		next();
	}
});

export default router;
